// extracted by mini-css-extract-plugin
export default {"backdrop":"ErrorModal_backdrop__iw-9R"};